import type { FeatureKey } from '@app/features/feature-keys.generated'
import featuresData from '@tenant-config/features/canada_env.json'
import configData from '@tenant-config/tenants/canada_env.json'

export const tenant: 'quebec_env' | 'canada_env' = 'canada_env'
export const features = featuresData as Readonly<Record<FeatureKey, boolean>>
export const tenantConfig = configData
